import { useContext, useState, useEffect } from 'react';
import "../ExamChoiceByGender/ExamChoiceByGender.css";
import { useNavigate } from 'react-router-dom';
import { Packs } from '../../Context/PacksContext';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpLong, faArrowRightLong } from "@fortawesome/free-solid-svg-icons";
import { useSearchParams } from "react-router-dom";
import TinyPageIcon from "../../../Photos/TinyPageIcon.png"
import TinyExamIcon from "../../../Photos/TinyExamIcon.png"
import packslist from "../../../../JSONS/physicalPacks.json"
import examslist from "../../../../JSONS/updatedExams.json"
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import MakeItEasy from "../../Landing/MakeItEasy"


function ExamChoiceByPhysicalSaleRoute() {

  const Navigate = useNavigate();
  const [searchParams] = useSearchParams();
  // Fix URL encoding: replace spaces with + signs (URL decodes + as space)
  const packParam = searchParams.get("pack");
  const [VisualizePack] = useState(packParam ? packParam.replace(/ /g, '+') : null);

  const MySwal = withReactContent(Swal)

  useEffect(() => {
    if(!searchParams.get("pack")) {
      Navigate("/packs-de-examenes")
    }
  })

  window.onscroll = function() {
    if(document.URL.includes("pack-fisico")) {
      let tmp = document.getElementById("ToTheTop")
      if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
        tmp.className = tmp.className.replace(" ScrollBackToTopHidden", "");
      } else {
        if(!tmp.className.includes("ScrollBackToTopHidden")) tmp.className += " ScrollBackToTopHidden"
      }
    }
  }
  
  const {
    BasketPacks, SetBasketPacks, ExamsPerProduct, SetExamsPerProduct
  } = useContext(Packs);

  const others = ["Imagenología", "Procedimientos"]

  // Check if pack exists in packslist before accessing its properties
  const packExists = VisualizePack && packslist[VisualizePack];
  
  const [Gender, setGender] = useState(
    !packExists ? null : 
    (packslist[VisualizePack].gender === "Mixed" || packslist[VisualizePack].gender.length === 0) && !packslist[VisualizePack].depends ? 'None' : 
    packslist[VisualizePack].gender === "M" ? 'M' : 'F'
  );
  const [ChosenExams, setChosenExams] = useState([]);
  const [OneTime, setOneTime] = useState(true);
  // Load price from cart if pack is already there, otherwise use default price
  const initialPrice = packExists ? 
    (BasketPacks.includes(VisualizePack) && ExamsPerProduct[VisualizePack] ? 
      ExamsPerProduct[VisualizePack].price : 
      packslist[VisualizePack].price) : 
    null;
  const [ProPrice, setProPrice] = useState(initialPrice);
  const [Page,setPage] = useState(1)
  const [ExamsShown,setExamsShown] = useState(window.innerWidth <= 420 ? 1 : window.innerWidth <= 720 ? 2 : 4)
  const [PackPage,setPackPage] = useState(1)
  const [PacksShown,setPacksShown] = useState(window.innerWidth <= 620 ? 1 : window.innerWidth <= 920 ? 2 : 3)
  const [AutoAdded, setAutoAdded] = useState(false);

  useEffect(() => {
    if(OneTime && document.getElementById("ManageAll")) {
      PreSelect()
      setOneTime(false)
      Navigate("/pack-fisico?pack=".concat(VisualizePack))
      // If pack is already in cart, mark as auto-added
      if(BasketPacks.includes(VisualizePack)) {
        setAutoAdded(true);
      }
    }
  })

  // Automatically add pack to cart when page loads (only if not already added)
  useEffect(() => {
    if(VisualizePack && ChosenExams.length > 0 && !AutoAdded && !BasketPacks.includes(VisualizePack)) {
      ModifyPackCheckout(VisualizePack);
      setAutoAdded(true);
    }
  }, [ChosenExams, VisualizePack, AutoAdded, BasketPacks])

  // Update the pack in cart whenever exam selection or price changes
  useEffect(() => {
    if(VisualizePack && AutoAdded && BasketPacks.includes(VisualizePack) && ChosenExams.length > 0) {
      UpdatePackInCart(VisualizePack);
    }
  }, [ChosenExams, ProPrice, VisualizePack, AutoAdded, BasketPacks])

  function PreSelect(gender = Gender) {
    // Check if pack is already in cart - if so, use cart exams instead of defaults
    const packInCart = BasketPacks.includes(VisualizePack);
    let Selected;
    
    // If pack is in cart, also load the saved price
    if(packInCart && ExamsPerProduct[VisualizePack]) {
      setProPrice(ExamsPerProduct[VisualizePack].price);
    }
    
    if(gender === "None") {
      // If pack is in cart, use exams from ExamsPerProduct, otherwise use default selected exams
      if(packInCart && ExamsPerProduct[VisualizePack]) {
        Selected = ExamsPerProduct[VisualizePack].exams;
      } else {
        Selected = packslist[VisualizePack].exams.filter((a,ind) => packslist[VisualizePack].selected[ind]);
      }
      
      let loadedExams = packslist[VisualizePack].exams.filter(a => examslist[a].emission !== "")
      for(let i=0;i<loadedExams.length;i++) {
        if(Selected.includes(loadedExams[i])) {
          let tmp = document.getElementById(loadedExams[i])
          if(tmp) tmp.checked = true
        }
      }
      setChosenExams(Selected.filter(a => loadedExams.includes(a)))
      //console.log(loadedExams)
    } else {
      // If pack is in cart, use exams from ExamsPerProduct, otherwise use default selected exams
      if(packInCart && ExamsPerProduct[VisualizePack]) {
        Selected = ExamsPerProduct[VisualizePack].exams;
      } else {
        Selected = packslist[VisualizePack][gender].exams.filter((a,ind) => packslist[VisualizePack][gender].selected[ind]);
      }
      
      let loadedExams = packslist[VisualizePack][gender].exams.filter(a => examslist[a].emission !== "")
      for(let i=0;i<loadedExams.length;i++) {
        if(Selected.includes(loadedExams[i])) {
          let tmp = document.getElementById(loadedExams[i])
          if(tmp) tmp.checked = true
        }
      }
      setChosenExams(Selected.filter(a => loadedExams.includes(a)))
    }
  }

  function toggleBack(current) {
    let tmp = document.getElementById("FemaleTab")
    let tmp2 = document.getElementById("MaleTab")
    if(current) {
      setGender('M')
      tmp.className = tmp.className.replace(" ExamChoiceByGenderActiveTag", "");
      tmp2.className += " ExamChoiceByGenderActiveTag";
      document.querySelectorAll('input[type=checkbox]').forEach(el => el.checked = false);
      //setChosenExams([]);
    } else {
      setGender('F')
      tmp2.className = tmp2.className.replace(" ExamChoiceByGenderActiveTag", "");
      tmp.className += " ExamChoiceByGenderActiveTag";
      document.querySelectorAll('input[type=checkbox]').forEach(el => el.checked = false);
      //setChosenExams([]);
    }
    setPage(1)
    let tmp3 = document.getElementsByClassName("ExamRecommendationFormInnerBoxLowerLinesIndividualPageDot")
    for(let i=0;i<tmp3.length;i++) {
      if(tmp3[i].className.includes("ActiveDot")) {
        tmp3[i].className = tmp3[i].className.replace(" ActiveDot", "");
      }
    }
    let tmp4 = document.getElementById('pageDot'.concat(1))
    tmp4.className += " ActiveDot"
    setOneTime(true)
    setProPrice(packslist[VisualizePack].price)
  }

  function handleChosen(id) {
    let tmp = document.getElementById(id)
    let listtmp = ChosenExams
    let fullprice = ProPrice
    if(id === 'ChooseAll') {
      if (tmp.checked) {
        fullprice = packslist[VisualizePack].price
        if(Gender === "None") {
          for(let i=0; i<packslist[VisualizePack].exams.length; i++) {
            let tmp2 = document.getElementById(packslist[VisualizePack].exams[i])
            if(tmp2) {
              tmp2.checked = true
              listtmp.push(packslist[VisualizePack].exams[i])
            }
          }
          for(let i=0; i<packslist[VisualizePack].examsPro.length; i++) {
            let tmp2 = document.getElementById(packslist[VisualizePack].examsPro[i])
            if(tmp2) {
              tmp2.checked = true
              //fullprice += packslist[VisualizePack].pricesPro[i]
              listtmp.push(packslist[VisualizePack].examsPro[i])
            } 
          }
        } else {
          for(let i=0; i<packslist[VisualizePack][Gender].exams.length; i++) {
            let tmp2 = document.getElementById(packslist[VisualizePack][Gender].exams[i])
            if(tmp2) {
              tmp2.checked = true
              listtmp.push(packslist[VisualizePack][Gender].exams[i])
            }
          }
          for(let i=0; i<packslist[VisualizePack][Gender].examsPro.length; i++) {
            let tmp2 = document.getElementById(packslist[VisualizePack][Gender].examsPro[i])
            if(tmp2) {
              tmp2.checked = true
              //fullprice += packslist[VisualizePack][Gender].pricesPro[i]
              listtmp.push(packslist[VisualizePack][Gender].examsPro[i])
            } 
          }
        }
      } else {
        fullprice = packslist[VisualizePack].price
        if(Gender === "None") {
          listtmp = []
          for(let i=0; i<packslist[VisualizePack].exams.length; i++) {
            let tmp2 = document.getElementById(packslist[VisualizePack].exams[i])
            if(tmp2) tmp2.checked = false
          }
          for(let i=0; i<packslist[VisualizePack].examsPro.length; i++) {
            let tmp2 = document.getElementById(packslist[VisualizePack].examsPro[i])
            if(tmp2) {
              tmp2.checked = false
            }
          }
        } else {
          listtmp = []
          for(let i=0; i<packslist[VisualizePack][Gender].exams.length; i++) {
            let tmp2 = document.getElementById(packslist[VisualizePack][Gender].exams[i])
            if(tmp2) tmp2.checked = false
          }
          for(let i=0; i<packslist[VisualizePack][Gender].examsPro.length; i++) {
            let tmp2 = document.getElementById(packslist[VisualizePack][Gender].examsPro[i])
            if(tmp2) {
              tmp2.checked = false
            } 
          }
        }
      }
    } else {
      if (tmp.checked) {
        listtmp.push(id)
        //if(Gender === "None") { 
        //  if(packslist[VisualizePack].examsPro.includes(id)) {
        //    let indexPro = packslist[VisualizePack].examsPro.indexOf(id);
        //    fullprice += packslist[VisualizePack].pricesPro[indexPro]
        //  }
        //}
        //if(Gender !== "None"){ 
        //  if(packslist[VisualizePack][Gender].examsPro.includes(id)) {
        //    let indexPro = packslist[VisualizePack][Gender].examsPro.indexOf(id);
        //    fullprice += packslist[VisualizePack][Gender].pricesPro[indexPro]
        //  }
        //}
      } else {
        let index = listtmp.indexOf(id);
        if (index > -1) { 
          listtmp.splice(index, 1); 
        }
        //if(Gender === "None") { 
        //  if(packslist[VisualizePack].examsPro.includes(id)) {
        //    let indexPro = packslist[VisualizePack].examsPro.indexOf(id);
        //    fullprice -= packslist[VisualizePack].pricesPro[indexPro]
        //  }
        //}
        //if(Gender !== "None"){ 
        //  if(packslist[VisualizePack][Gender].examsPro.includes(id)) {
        //    let indexPro = packslist[VisualizePack][Gender].examsPro.indexOf(id);
        //    fullprice -= packslist[VisualizePack][Gender].pricesPro[indexPro]
        //  }
        //}
      }
    }

    //if(fullprice !== ProPrice) {
    //  changePriceSize()
    //}

    //setProPrice(fullprice)
    setChosenExams([...new Set(listtmp)])
    
    // Update the pack in cart immediately after changing exam selection
    if(VisualizePack && BasketPacks.includes(VisualizePack) && [...new Set(listtmp)].length > 0) {
      // Use setTimeout to ensure state is updated first
      setTimeout(() => {
        UpdatePackInCartDirect(VisualizePack, [...new Set(listtmp)], fullprice)
      }, 0)
    }
  }

  function delay(time) {
    return new Promise(resolve => setTimeout(resolve, time));
  }

  //async function changePriceSize() {
  //  let tmpPrice = document.getElementById("PriceDiv")
  //  tmpPrice.className += " PriceChanged"
  //  await delay(1000);
  //  tmpPrice.className = tmpPrice.className.replace(" PriceChanged","")
  //}

  function ModifyPackCheckout(pack) {
    // Only add the pack if it's not already in the basket
    if(!BasketPacks.includes(pack)) {
        let dict = {
          "exams": [...ChosenExams],
          "price": ProPrice
        }
        // Create new arrays/objects to ensure React detects changes
        SetBasketPacks([...BasketPacks, pack])
        SetExamsPerProduct({
          ...ExamsPerProduct,
          [pack]: dict
        })
    }
  }

  function UpdatePackInCart(pack) {
    // Create a completely new object to ensure React detects the change
    let dict = {
      "exams": [...ChosenExams],
      "price": ProPrice
    }
    // Create new ExamsPerProduct object with updated pack
    let updatedExamsOfPacks = {
      ...ExamsPerProduct,
      [pack]: dict
    }
    SetExamsPerProduct(updatedExamsOfPacks)
  }

  function UpdatePackInCartDirect(pack, exams, price) {
    // Direct update with passed values (not from state)
    let dict = {
      "exams": [...exams],
      "price": price
    }
    // Create new ExamsPerProduct object with updated pack
    let updatedExamsOfPacks = {
      ...ExamsPerProduct,
      [pack]: dict
    }
    SetExamsPerProduct(updatedExamsOfPacks)
  }

  function toggleAdditional(id) {
    let tmp = document.getElementById(id)
    if(tmp.className.includes("InformationCollapsed")) {
      tmp.className = tmp.className.replace(" InformationCollapsed", "");
    } else {
      tmp.className += " InformationCollapsed"
    }
  }

  function toggleDescription(id,type) {
    let tmp = document.getElementById(id.concat("More"))
    let tmp2 = document.getElementById(id.concat("Less"))
    if(type === "More") {
        tmp.className += " ExamsByPacksPackBoxWhiteBoxDescriptionHidden"
        tmp2.className = tmp2.className.replace(" ExamsByPacksPackBoxWhiteBoxDescriptionHidden", "");
    } else {
        tmp.className = tmp.className.replace(" ExamsByPacksPackBoxWhiteBoxDescriptionHidden", "");
        tmp2.className += " ExamsByPacksPackBoxWhiteBoxDescriptionHidden"
    }
  }

  function changeExamPage(num) {
    setPage(num+Page)
    let tmp = document.getElementsByClassName("ExamRecommendationFormInnerBoxLowerLinesIndividualPageDot")
    for(let i=0;i<tmp.length;i++) {
      if(tmp[i].className.includes("ActiveDot")) {
        tmp[i].className = tmp[i].className.replace(" ActiveDot", "");
      }
    }
    let tmp2 = document.getElementById('pageDot'.concat(num+Page))
    tmp2.className += " ActiveDot"
  }

  function ChangeNumberOfExams() {
    let current = ExamsShown
    let current2 = PacksShown
    let different = false
    let different2 = false

    if(window.innerWidth <= 420) {
      setExamsShown(1)
      if(current !== 1) different = true
    } else if(window.innerWidth <= 720) {
      setExamsShown(2)
      if(current !== 2) different = true
    } else {
      setExamsShown(4)
      if(current !== 4) different = true
    }

    if(window.innerWidth <= 620) {
      setPacksShown(1)
      if(current2 !== 1) different2 = true
    } else if(window.innerWidth <= 920) {
      setPacksShown(2)
      if(current2 !== 2) different2 = true
    } else {
      setPacksShown(3)
      if(current2 !== 3) different2 = true
    }

    if(different) {
      setPage(1)
      let tmp = document.getElementsByClassName("ExamRecommendationFormInnerBoxLowerLinesIndividualPageDot")
      for(let i=0;i<tmp.length;i++) {
        if(tmp[i].className.includes("ActiveDot")) {
          tmp[i].className = tmp[i].className.replace(" ActiveDot", "");
        }
      }
      let tmp2 = document.getElementById('pageDot'.concat(1))
      if (tmp2) tmp2.className += " ActiveDot"
    }

    if(different2) {
      setPackPage(1)
    }
  }

  useEffect(() => {
    window.addEventListener("resize", ChangeNumberOfExams);
    return () => window.removeEventListener("resize", ChangeNumberOfExams);
  }, [ChangeNumberOfExams]);
  
    return (
      <>
      {!packExists ?
      <div className="ExamChoiceByGenderAllOuter">
        <div style={{padding: "40px", textAlign: "center"}}>
          <h2>Pack no encontrado</h2>
          <p>El pack que estás buscando no existe o el enlace es incorrecto.</p>
          <button onClick={() => Navigate("/packs-de-examenes")} style={{padding: "10px 20px", marginTop: "20px", cursor: "pointer"}}>
            Ver Packs Disponibles
          </button>
        </div>
      </div>
      :
      <>
      <div className="ExamChoiceByGenderAllOuter">
     <div className="ExamChoiceByGenderAll" id="ManageAll">
      <div className="ExamChoiceByGenderLeftSide">
        <div className="ExamChoiceByGenderLeftSideUpperBlock">
        <div className="ExamChoiceByGenderPackBoxImage" style={{backgroundImage:"url('https://static.yomecontrolo.cl/public/img/packs/"+ VisualizePack +".png')",backgroundPosition: 'center',backgroundPositionY: 'top',backgroundSize: 'cover',backgroundRepeat: 'no-repeat'}}><div className="ExamChoiceByGenderPackBoxImageGradient"></div></div>
        <div className="ExamChoiceByGenderPackTextContainter">
          <h2 className="ExamChoiceByGenderPackTitle">{packslist[VisualizePack].name}</h2>
          <div className="ExamChoiceByGenderPackDescription">{packslist[VisualizePack].description}</div>
          <div className='ExamChoiceByGenderPackPriceFlex'>
            {ProPrice === 0 ?
            <div className='ExamChoiceByGenderPackPriceFree' id="PriceDiv">Gratis</div>
            :
            <div className='ExamChoiceByGenderPackPrice' id="PriceDiv"></div>
}
            {/*BasketPacks.includes(VisualizePack) ?
            <div className='ExamChoiceByGenderPackAddToOrderButton'  
                onClick={() => {ModifyPackCheckout(VisualizePack); MySwal.fire({
                position: "top-end",
                icon: "success",
                iconColor: "red",
                title: "Se ha eliminado el pack de su orden médica",
                showConfirmButton: false,
                timer: 1500
              });}}>Eliminar de Orden Médica</div>
            : ChosenExams.length === 0 ? 
            <div className='ExamChoiceByGenderPackAddToOrderButtonDisabled'>Añadir a Orden Médica</div>
            :
            <div className='ExamChoiceByGenderPackAddToOrderButton' 
                onClick={() => {ModifyPackCheckout(VisualizePack); MySwal.fire({
                title: "Se ha añadido el pack a su orden médica",
                confirmButtonText: "Genera tu órden médica"
              }).then((result) => {
                if (result.isConfirmed) {
                  Navigate("/orden-medica");
                }
              });}}>Añadir a Orden Médica</div>
*/}
            <div className='ExamChoiceByGenderPackAddToOrderButton' onClick={() => Navigate("/orden-medica")}>Continuar</div>
          </div>
        </div>
        </div>
 
      </div>
      <div className="ExamChoiceByGenderRightSide">
      {packslist[VisualizePack].depends & packslist[VisualizePack].gender === "Mixed" ?
        <div className="ExamChoiceByGenderUpperTags">
          {Gender === 'F' ?
          <>
          <div className="ExamChoiceByGenderFemaleTag ExamChoiceByGenderActiveTag" id="FemaleTab">Mujer</div>
          <div className="ExamChoiceByGenderMaleTag" id="MaleTab" onClick={() => toggleBack(true)}>Hombre</div>
          </>
          :
          <>
          <div className="ExamChoiceByGenderFemaleTag ExamChoiceByGenderActiveTag" id="FemaleTab" onClick={() => toggleBack(false)}>Mujer</div>
          <div className="ExamChoiceByGenderMaleTag" id="MaleTab">Hombre</div>
          </>
      }
        </div>
        : packslist[VisualizePack].depends & packslist[VisualizePack].gender === "F" ?
          <div className="ExamChoiceByGenderUpperTags">
            <div className="ExamChoiceByGenderFemaleTag ExamChoiceByGenderActiveTag" id="FemaleTab">Mujer</div>
          </div>
        : packslist[VisualizePack].depends & packslist[VisualizePack].gender === "M" ?
          <div className="ExamChoiceByGenderUpperTags">
            <div className="ExamChoiceByGenderMaleTag ExamChoiceByGenderActiveTag" id="MaleTab">Hombre</div>
          </div>
        : 
          <div className="ExamChoiceByGenderUpperTags">
            <div className="ExamChoiceByGenderMaleTag ExamChoiceByGenderActiveTag" id="MaleTab">Hombres y Mujeres</div>
          </div>
        }
        <div className="ExamChoiceByGenderChoiceContainer">
        {/*packslist[VisualizePack].depends & packslist[VisualizePack].gender === "Mixed" ?
        <>
          {Gender === 'F' ?
          <div className="ExamChoiceByGenderChoiceRightText">
            Exámenes Preventivos / Mujer
          </div>
          :
          <div className="ExamChoiceByGenderChoiceRightText">
            Exámenes Preventivos / Hombre
          </div>
          }
        </>
        : packslist[VisualizePack].depends & packslist[VisualizePack].gender === "F" ?
          <div className="ExamChoiceByGenderChoiceRightText">
            Exámenes Preventivos / Mujer
          </div>
        : packslist[VisualizePack].depends & packslist[VisualizePack].gender === "M" ?
          <div className="ExamChoiceByGenderChoiceRightText">
            Exámenes Preventivos / Hombre
          </div>
        :
          <div className="ExamChoiceByGenderChoiceRightText">
            Exámenes Preventivos / Mixto
          </div>
        */}
          <div className="ExamChoiceByGenderChoiceDescription">
            Un chequeo preventivo te permitirá conocer tu estado de salud para evitar aparición de enfermedades y abordaje temprano de posibles síntomas.
            Escoge aquí los exámenes del pack que te interesan.
          </div>
          <div className="ExamChoiceByGenderChoiceChooseAllDiv">
            <input type="checkbox" name="selectExam" className="ExamChoiceByGenderChoiceChooseAllInput" id={'ChooseAll'} onClick={() => handleChosen('ChooseAll')}/>
            <span className="ExamChoiceByGenderChoiceChooseAllText">Elegir todos</span>
          </div>
          {packslist[VisualizePack].depends ?
          <>
          {packslist[VisualizePack][Gender].exams.map(a => examslist[a].emission).includes('Laboratorio') | packslist[VisualizePack][Gender].examsPro.map(a => examslist[a].emission).includes('Laboratorio') ?
          <>
            <div className="ExamChoiceByGenderChoiceLabel">
              Laboratorio
            </div>
            <div className="ExamChoiceByGenderChoiceExams">
            {packslist[VisualizePack][Gender].exams.map((key) => (
              <div key={key}>
              {examslist[key].emission === "Laboratorio" ?
              <>
              <div className="ExamChoiceByGenderChoiceExamsFlexed">
                <input type="checkbox" name="selectExam" className="ExamChoiceByGenderChoiceExamSelect" id={key} onClick={() => handleChosen(key)}/>
                <span className="ExamChoiceByGenderChoiceExamName">{examslist[key].name}</span>
                {examslist[key].additional === "" ?
                null :
                  <div className="ExamChoiceByGenderChoiceExamInfo" onClick={() => toggleAdditional("Added".concat(key))}>?</div>
                }
              </div>
              <div className="ExamChoiceByGenderChoiceSpecifics InformationCollapsed" id={"Added".concat(key)}>{examslist[key].additional}</div>
              </>
              :
              null}
              </div>
            ))}
            {[...Array(packslist[VisualizePack][Gender].examsPro.length).keys()].map((key) => (
              <div key={key}>
              {examslist[packslist[VisualizePack][Gender].examsPro[key]].emission === "Laboratorio" ?
              <>
              <div className="ExamChoiceByGenderChoiceExamsFlexed">
                <input type="checkbox" name="selectExam" className="ExamChoiceByGenderChoiceExamSelect" id={packslist[VisualizePack][Gender].examsPro[key]} onClick={() => handleChosen(packslist[VisualizePack][Gender].examsPro[key])}/>
                <span className="ExamChoiceByGenderChoiceExamName"><span className="ExamChoiceByGenderChoiceExamPRO">PRO</span> {examslist[packslist[VisualizePack][Gender].examsPro[key]].name}</span>
                {examslist[packslist[VisualizePack][Gender].examsPro[key]].additional === "" ?
                null :
                  <div className="ExamChoiceByGenderChoiceExamInfo" onClick={() => toggleAdditional("Added".concat(key))}>?</div>
                }
                <div className="ExamChoiceByGenderChoiceExamPrice">(+${packslist[VisualizePack][Gender].pricesPro[key]})</div>
              </div>
              <div className="ExamChoiceByGenderChoiceSpecifics InformationCollapsed" id={"Added".concat(key)}>{examslist[packslist[VisualizePack][Gender].examsPro[key]].additional}</div>
              </>
              :
              null}
              </div>
            ))}
            </div> 
          </>
          : null}
          {others.some((el) => packslist[VisualizePack][Gender].exams.map(a => examslist[a].emission).includes(el)) | others.some((el) => packslist[VisualizePack][Gender].examsPro.map(a => examslist[a].emission).includes(el)) ?
          <>
            <div className="ExamChoiceByGenderChoiceLabel">
              Imagenología y Procedimientos
            </div>
            <div className="ExamChoiceByGenderChoiceExams">
            {packslist[VisualizePack][Gender].exams.map((key) => (
              <div key={key}>
              {examslist[key].emission === "Imagenología" | examslist[key].emission === "Procedimientos" ?
              <>
              <div className="ExamChoiceByGenderChoiceExamsFlexed">
                <input type="checkbox" name="selectExam" className="ExamChoiceByGenderChoiceExamSelect" id={key} onClick={() => handleChosen(key)} />
                <span className="ExamChoiceByGenderChoiceExamName">{examslist[key].name}</span>
                {examslist[key].additional === "" ?
                null :
                  <div className="ExamChoiceByGenderChoiceExamInfo" onClick={() => toggleAdditional("Added".concat(key))}>?</div>
                }
              </div>
              <div className="ExamChoiceByGenderChoiceSpecifics InformationCollapsed" id={"Added".concat(key)}>{examslist[key].additional}</div>
              </>
              :
              null}
              </div>
            ))}
            {[...Array(packslist[VisualizePack][Gender].examsPro.length).keys()].map((key) => (
              <div key={key}>
              {examslist[packslist[VisualizePack][Gender].examsPro[key]].emission === "Imagenología" | examslist[packslist[VisualizePack][Gender].examsPro[key]].emission === "Procedimientos" ?
              <>
              <div className="ExamChoiceByGenderChoiceExamsFlexed">
                <input type="checkbox" name="selectExam" className="ExamChoiceByGenderChoiceExamSelect" id={packslist[VisualizePack][Gender].examsPro[key]} onClick={() => handleChosen(packslist[VisualizePack][Gender].examsPro[key])}/>
                <span className="ExamChoiceByGenderChoiceExamName"><span className="ExamChoiceByGenderChoiceExamPRO">PRO</span> {examslist[packslist[VisualizePack][Gender].examsPro[key]].name}</span>
                {examslist[packslist[VisualizePack][Gender].examsPro[key]].additional === "" ?
                null :
                  <div className="ExamChoiceByGenderChoiceExamInfo" onClick={() => toggleAdditional("Added".concat(key))}>?</div>
                }
                <div className="ExamChoiceByGenderChoiceExamPrice">(+${packslist[VisualizePack][Gender].pricesPro[key]})</div>
              </div>
              <div className="ExamChoiceByGenderChoiceSpecifics InformationCollapsed" id={"Added".concat(key)}>{examslist[packslist[VisualizePack][Gender].examsPro[key]].additional}</div>
              </>
              :
              null}
              </div>
            ))}
            </div>
          </>
          : null}
          {packslist[VisualizePack][Gender].exams.map(a => examslist[a].emission).includes('Derivaciones') | packslist[VisualizePack][Gender].examsPro.map(a => examslist[a].emission).includes('Derivaciones') ?
          <>
            <div className="ExamChoiceByGenderChoiceLabel">
              Derivaciones
            </div>
            <div className="ExamChoiceByGenderChoiceExams">
            {packslist[VisualizePack][Gender].exams.map((key) => (
              <div key={key}>
              {examslist[key].emission === "Derivaciones" ?
              <>
              <div className="ExamChoiceByGenderChoiceExamsFlexed">
                <input type="checkbox" name="selectExam" className="ExamChoiceByGenderChoiceExamSelect" id={key} onClick={() => handleChosen(key)} />
                <span className="ExamChoiceByGenderChoiceExamName">{examslist[key].name}</span>
                {examslist[key].additional === "" ?
                null :
                  <div className="ExamChoiceByGenderChoiceExamInfo" onClick={() => toggleAdditional("Added".concat(key))}>?</div>
                }
              </div>
              <div className="ExamChoiceByGenderChoiceSpecifics InformationCollapsed" id={"Added".concat(key)}>{examslist[key].additional}</div>
              </>
              :
              null}
              </div>
            ))}
            {[...Array(packslist[VisualizePack][Gender].examsPro.length).keys()].map((key) => (
              <div key={key}>
              {examslist[packslist[VisualizePack][Gender].examsPro[key]].emission === "Derivaciones" ?
              <>
              <div className="ExamChoiceByGenderChoiceExamsFlexed">
                <input type="checkbox" name="selectExam" className="ExamChoiceByGenderChoiceExamSelect" id={packslist[VisualizePack][Gender].examsPro[key]} onClick={() => handleChosen(packslist[VisualizePack][Gender].examsPro[key])}/>
                <span className="ExamChoiceByGenderChoiceExamName"><span className="ExamChoiceByGenderChoiceExamPRO">PRO</span> {examslist[packslist[VisualizePack][Gender].examsPro[key]].name}</span>
                {examslist[packslist[VisualizePack][Gender].examsPro[key]].additional === "" ?
                null :
                  <div className="ExamChoiceByGenderChoiceExamInfo" onClick={() => toggleAdditional("Added".concat(key))}>?</div>
                }
                <div className="ExamChoiceByGenderChoiceExamPrice">(+${packslist[VisualizePack][Gender].pricesPro[key]})</div>
              </div>
              <div className="ExamChoiceByGenderChoiceSpecifics InformationCollapsed" id={"Added".concat(key)}>{examslist[packslist[VisualizePack][Gender].examsPro[key]].additional}</div>
              </>
              :
              null}
              </div>
            ))}
            </div>
          </>
          : null}
          </>
          
        : 
          <>
          {packslist[VisualizePack].exams.map(a => examslist[a].emission).includes('Laboratorio') | packslist[VisualizePack].examsPro.map(a => examslist[a].emission).includes('Laboratorio') ?
          <>
            <div className="ExamChoiceByGenderChoiceLabel">
              Laboratorio
            </div>
            <div className="ExamChoiceByGenderChoiceExams">
            
            <>
            {packslist[VisualizePack].exams.map((key) => (
              <div key={key}>
              {examslist[key].emission === "Laboratorio" ?
              <>
              <div className="ExamChoiceByGenderChoiceExamsFlexed">
                <input type="checkbox" name="selectExam" className="ExamChoiceByGenderChoiceExamSelect" id={key} onClick={() => handleChosen(key)}/>
                <span className="ExamChoiceByGenderChoiceExamName">{examslist[key].name}</span>
                {examslist[key].additional === "" ?
                null :
                  <div className="ExamChoiceByGenderChoiceExamInfo" onClick={() => toggleAdditional("Added".concat(key))}>?</div>
                }
              </div>
              <div className="ExamChoiceByGenderChoiceSpecifics InformationCollapsed" id={"Added".concat(key)}>{examslist[key].additional}</div>
              </>
              :
              null}
              </div>
            ))}
            </>
            
            <>
            {packslist[VisualizePack].examsPro.length !== 0 ?
            <>
              {[...Array(packslist[VisualizePack].examsPro.length).keys()].map((key) => (
                <div key={key}>
                {examslist[packslist[VisualizePack].examsPro[key]].emission === "Laboratorio" ?
                <>
                <div className="ExamChoiceByGenderChoiceExamsFlexed">
                  <input type="checkbox" name="selectExam" className="ExamChoiceByGenderChoiceExamSelect" id={packslist[VisualizePack].examsPro[key]} onClick={() => handleChosen(packslist[VisualizePack].examsPro[key])}/>
                  <span className="ExamChoiceByGenderChoiceExamName"><span className="ExamChoiceByGenderChoiceExamPRO">PRO</span> {examslist[packslist[VisualizePack].examsPro[key]].name}</span>
                  {examslist[packslist[VisualizePack].examsPro[key]].additional === "" ?
                null :
                  <div className="ExamChoiceByGenderChoiceExamInfo" onClick={() => toggleAdditional("Added".concat(key))}>?</div>
                }
                {/*<div className="ExamChoiceByGenderChoiceExamPrice">(+${packslist[VisualizePack].pricesPro[key]})</div>*/}
              </div>
              <div className="ExamChoiceByGenderChoiceSpecifics InformationCollapsed" id={"Added".concat(key)}>{examslist[packslist[VisualizePack].examsPro[key]].additional}</div>
              </>
                :
                null}
                </div>
              ))}
              </>: null}
              </>
            </div> 
          </>
          : null}
          {others.some((el) => packslist[VisualizePack].exams.map(a => examslist[a].emission).includes(el)) | others.some((el) => packslist[VisualizePack].examsPro.map(a => examslist[a].emission).includes(el)) ?
          <>
            <div className="ExamChoiceByGenderChoiceLabel">
              Imagenología y Procedimientos
            </div>
            <div className="ExamChoiceByGenderChoiceExams">
            {packslist[VisualizePack].exams.map((key) => (
              <div key={key}>
              {examslist[key].emission === "Imagenología" | examslist[key].emission === "Procedimientos" ?
              <>
              <div className="ExamChoiceByGenderChoiceExamsFlexed">
                <input type="checkbox" name="selectExam" className="ExamChoiceByGenderChoiceExamSelect" id={key} onClick={() => handleChosen(key)} />
                <span className="ExamChoiceByGenderChoiceExamName">{examslist[key].name}</span>
                {examslist[key].additional === "" ?
                null :
                  <div className="ExamChoiceByGenderChoiceExamInfo" onClick={() => toggleAdditional("Added".concat(key))}>?</div>
                }
              </div>
              <div className="ExamChoiceByGenderChoiceSpecifics InformationCollapsed" id={"Added".concat(key)}>{examslist[key].additional}</div>
              </>
              :
              null}
              </div>
            ))}
            {[...Array(packslist[VisualizePack].examsPro.length).keys()].map((key) => (
              <div key={key}>
              {examslist[packslist[VisualizePack].examsPro[key]].emission === "Imagenología" | examslist[packslist[VisualizePack].examsPro[key]].emission === "Procedimientos" ?
              <>
              <div className="ExamChoiceByGenderChoiceExamsFlexed">
                <input type="checkbox" name="selectExam" className="ExamChoiceByGenderChoiceExamSelect" id={packslist[VisualizePack].examsPro[key]} onClick={() => handleChosen(packslist[VisualizePack].examsPro[key])} />
                <span className="ExamChoiceByGenderChoiceExamName"><span className="ExamChoiceByGenderChoiceExamPRO">PRO</span> {examslist[packslist[VisualizePack].examsPro[key]].name}</span>
                {examslist[packslist[VisualizePack].examsPro[key]].additional === "" ?
                null :
                  <div className="ExamChoiceByGenderChoiceExamInfo" onClick={() => toggleAdditional("Added".concat(key))}>?</div>
                }
                <div className="ExamChoiceByGenderChoiceExamPrice">(+${packslist[VisualizePack].pricesPro[key]})</div>
              </div>
              <div className="ExamChoiceByGenderChoiceSpecifics InformationCollapsed" id={"Added".concat(key)}>{examslist[packslist[VisualizePack].examsPro[key]].additional}</div>
              </>
              :
              null}
              </div>
            ))}
            </div>
          </>
          : null}
          {packslist[VisualizePack].exams.map(a => examslist[a].emission).includes('Derivaciones') | packslist[VisualizePack].examsPro.map(a => examslist[a].emission).includes('Derivaciones') ?
          <>
            <div className="ExamChoiceByGenderChoiceLabel">
              Derivaciones
            </div>
            <div className="ExamChoiceByGenderChoiceExams">
            {packslist[VisualizePack].exams.map((key) => (
              <div key={key}>
              {examslist[key].emission === "Derivaciones" ?
              <>
              <div className="ExamChoiceByGenderChoiceExamsFlexed">
                <input type="checkbox" name="selectExam" className="ExamChoiceByGenderChoiceExamSelect" id={key} onClick={() => handleChosen(key)} />
                <span className="ExamChoiceByGenderChoiceExamName">{examslist[key].name}</span>
                {examslist[key].additional === "" ?
                null :
                  <div className="ExamChoiceByGenderChoiceExamInfo" onClick={() => toggleAdditional("Added".concat(key))}>?</div>
                }
              </div>
              <div className="ExamChoiceByGenderChoiceSpecifics InformationCollapsed" id={"Added".concat(key)}>{examslist[key].additional}</div>
              </>
              :
              null}
              </div>
            ))}
            {[...Array(packslist[VisualizePack].examsPro.length).keys()].map((key) => (
              <div key={key}>
              {examslist[packslist[VisualizePack].examsPro[key]].emission === "Derivaciones" ?
              <>
              <div className="ExamChoiceByGenderChoiceExamsFlexed">
                <input type="checkbox" name="selectExam" className="ExamChoiceByGenderChoiceExamSelect" id={packslist[VisualizePack].examsPro[key]} onClick={() => handleChosen(packslist[VisualizePack].examsPro[key])} />
                <span className="ExamChoiceByGenderChoiceExamName"><span className="ExamChoiceByGenderChoiceExamPRO">PRO</span> {examslist[packslist[VisualizePack].examsPro[key]].name}</span>
                {examslist[packslist[VisualizePack].examsPro[key]].additional === "" ?
                null :
                  <div className="ExamChoiceByGenderChoiceExamInfo" onClick={() => toggleAdditional("Added".concat(key))}>?</div>
                }
                <div className="ExamChoiceByGenderChoiceExamPrice">(+${packslist[VisualizePack].pricesPro[key]})</div>
              </div>
              <div className="ExamChoiceByGenderChoiceSpecifics InformationCollapsed" id={"Added".concat(key)}>{examslist[packslist[VisualizePack].examsPro[key]].additional}</div>
              </>
              :
              null}
              </div>
            ))}
            </div>
          </>
          : null}
          </> }
        </div>
      </div>
     </div>

     {packslist[VisualizePack].depends ?
     <div className='ExamChoiceByGenderAllExamsDivContainer'>
     <div className='ExamChoiceByGenderAllExamsDiv'>
       <div>Exámenes:&ensp; ({[...packslist[VisualizePack][Gender].exams.filter(obj => examslist[obj].emission !== "Derivaciones" && examslist[obj].emission !== ""),...packslist[VisualizePack][Gender].examsPro.filter(obj => examslist[obj].emission !== "Derivaciones" && examslist[obj].emission !== "")].length}) &nbsp;
         <img className="ExamChoiceByGenderAllExamsPageIcon" alt='' src={TinyPageIcon} />
       </div>
       <div className="ExamChoiceByGenderAllExamsHorizontalLine"></div>
         <div className="ExamChoiceByGenderAllExamsFlexFullLine">
           {Page === 1 ?
           null :
           <div className='ExamChoiceByGenderAllExamsLeftArrowDiv' onClick={() => changeExamPage(-1)}>
             <FontAwesomeIcon 
               icon={faArrowRightLong} 
               className='ExamChoiceByGenderAllExamsLeftArrow text-end fa-rotate-180'
             />
           </div>
           }
           <div className="ExamChoiceByGenderAllExamsFlexExamLine">
             {[...packslist[VisualizePack][Gender].exams.filter(obj => examslist[obj].emission !== "Derivaciones" && examslist[obj].emission !== ""),...packslist[VisualizePack][Gender].examsPro.filter(obj => examslist[obj].emission !== "Derivaciones" && examslist[obj].emission !== "")].slice(ExamsShown*(Page-1),ExamsShown*Page).map((exam) => (
             <div className="ExamChoiceByGenderAllExamsSingleExamBlock" key={exam}>
               <div className="ExamChoiceByGenderAllExamsSingleExamBlockUpLine">
                 <img className="ExamChoiceByGenderAllExamsExamIcon" alt='' src={TinyExamIcon} />&ensp;
                 <div className="ExamChoiceByGenderAllExamsSingleExamBlockName">{examslist[exam].name}</div>
               </div>
               <div className="ExamChoiceByGenderAllExamsSingleExamBlockDescr">{examslist[exam].description}</div>
             </div>
             ))}
           </div>
           {Page === Math.ceil([...packslist[VisualizePack][Gender].exams.filter(obj => examslist[obj].emission !== "Derivaciones" && examslist[obj].emission !== ""),...packslist[VisualizePack][Gender].examsPro.filter(obj => examslist[obj].emission !== "Derivaciones" && examslist[obj].emission !== "")].length / ExamsShown) ?
           null :
           <div className='ExamChoiceByGenderAllExamsRightArrowDiv' onClick={() => changeExamPage(1)}>
             <FontAwesomeIcon 
               icon={faArrowRightLong} 
               className='ExamChoiceByGenderAllExamsRightArrow text-end'
             />
           </div>
           }
         </div>
         <div className='ExamChoiceByGenderAllExamsDotsDiv'>
           <div className="ExamRecommendationFormInnerBoxLowerLinesIndividualPageDot ActiveDot" id="pageDot1"></div>
           {[...Array(Math.ceil([...packslist[VisualizePack][Gender].exams.filter(obj => examslist[obj].emission !== "Derivaciones" && examslist[obj].emission !== ""),...packslist[VisualizePack][Gender].examsPro.filter(obj => examslist[obj].emission !== "Derivaciones" && examslist[obj].emission !== "")].length / ExamsShown)-1).keys()].map((dots) => (
             <div className="ExamRecommendationFormInnerBoxLowerLinesIndividualPageDot" key={'pageDot'.concat(dots+2)} id={'pageDot'.concat(dots+2)}></div>
           ))}
         </div>
         {[...packslist[VisualizePack][Gender].exams.filter(obj => examslist[obj].emission === "Derivaciones"),...packslist[VisualizePack][Gender].examsPro.filter(obj => examslist[obj].emission === "Derivaciones")].length !== 0 ?
         <>
         <div className="ExamChoiceByGenderAllExamsDerivations">
          <div>Derivaciones:&ensp; ({[...packslist[VisualizePack][Gender].exams.filter(obj => examslist[obj].emission === "Derivaciones"),...packslist[VisualizePack][Gender].examsPro.filter(obj => examslist[obj].emission === "Derivaciones")].length}) &nbsp;
          <img className="ExamChoiceByGenderAllExamsPageIcon" alt='' src={TinyPageIcon} />
        </div>
        <div className="ExamChoiceByGenderAllExamsHorizontalLine"></div>
          <div className="ExamChoiceByGenderAllExamsFlexFullLine">
            <div className="ExamChoiceByGenderAllDerivationsFlexExamLine">
              {[...packslist[VisualizePack][Gender].exams.filter(obj => examslist[obj].emission === "Derivaciones"),...packslist[VisualizePack][Gender].examsPro.filter(obj => examslist[obj].emission === "Derivaciones")].map((exam) => (
              <div className="ExamChoiceByGenderAllDerivationsSingleExamBlock" key={exam}>
                <div className="ExamChoiceByGenderAllExamsSingleExamBlockUpLine">
                  <img className="ExamChoiceByGenderAllExamsExamIcon" alt='' src={TinyExamIcon} />&ensp;
                  <div className="ExamChoiceByGenderAllExamsSingleExamBlockName">{examslist[exam].name}</div>
                </div>
                <div className="ExamChoiceByGenderAllExamsSingleExamBlockDescr">{examslist[exam].description}</div>
              </div>
              ))}
            </div>
          </div>
        </div>
        </>
        : null}
     </div>
    </div>
     :
     <div className='ExamChoiceByGenderAllExamsDivContainer'>
      <div className='ExamChoiceByGenderAllExamsDiv'>
        { [...packslist[VisualizePack].exams.filter(obj => examslist[obj].emission !== "Derivaciones" && examslist[obj].emission !== ""),...packslist[VisualizePack].examsPro.filter(obj => examslist[obj].emission !== "Derivaciones" && examslist[obj].emission !== "")].length === 0 ?
        null :
        <>
        <h5 className="ExamChoiceByGenderAllExamsPageMainTitle">Exámenes:&ensp; ({[...packslist[VisualizePack].exams.filter(obj => examslist[obj].emission !== "Derivaciones" && examslist[obj].emission !== ""),...packslist[VisualizePack].examsPro.filter(obj => examslist[obj].emission !== "Derivaciones" && examslist[obj].emission !== "")].length}) &nbsp;
          <img className="ExamChoiceByGenderAllExamsPageIcon" alt='' src={TinyPageIcon} />
        </h5>
        <div className="ExamChoiceByGenderAllExamsHorizontalLine"></div>
          <div className="ExamChoiceByGenderAllExamsFlexFullLine">
            {Page === 1 ?
            null :
            <div className='ExamChoiceByGenderAllExamsLeftArrowDiv' onClick={() => changeExamPage(-1)}>
              <FontAwesomeIcon 
                icon={faArrowRightLong} 
                className='ExamChoiceByGenderAllExamsLeftArrow text-end fa-rotate-180'
              />
            </div>
            }
            <div className="ExamChoiceByGenderAllExamsFlexExamLine">
              {[...packslist[VisualizePack].exams.filter(obj => examslist[obj].emission !== "Derivaciones" && examslist[obj].emission !== ""),...packslist[VisualizePack].examsPro.filter(obj => examslist[obj].emission !== "Derivaciones" && examslist[obj].emission !== "")].slice(ExamsShown*(Page-1),ExamsShown*Page).map((exam) => (
              <div className="ExamChoiceByGenderAllExamsSingleExamBlock" key={exam}>
                <div className="ExamChoiceByGenderAllExamsSingleExamBlockUpLine">
                  <img className="ExamChoiceByGenderAllExamsExamIcon" alt='' src={TinyExamIcon} />&ensp;
                  <div className="ExamChoiceByGenderAllExamsSingleExamBlockName">{examslist[exam].name}</div>
                </div>
                <div className="ExamChoiceByGenderAllExamsSingleExamBlockDescr">{examslist[exam].description}</div>
              </div>
              ))}
            </div>
            {Page === Math.ceil([...packslist[VisualizePack].exams.filter(obj => examslist[obj].emission !== "Derivaciones" && examslist[obj].emission !== ""),...packslist[VisualizePack].examsPro.filter(obj => examslist[obj].emission !== "Derivaciones" && examslist[obj].emission !== "")].length / ExamsShown) ?
            null :
            <div className='ExamChoiceByGenderAllExamsRightArrowDiv' onClick={() => changeExamPage(1)}>
              <FontAwesomeIcon 
                icon={faArrowRightLong} 
                className='ExamChoiceByGenderAllExamsRightArrow text-end'
              />
            </div>
            }
          </div>
          <div className='ExamChoiceByGenderAllExamsDotsDiv'>
            <div className="ExamRecommendationFormInnerBoxLowerLinesIndividualPageDot ActiveDot" id="pageDot1"></div>
            {[...Array(Math.ceil([...packslist[VisualizePack].exams.filter(obj => examslist[obj].emission !== "Derivaciones" && examslist[obj].emission !== ""),...packslist[VisualizePack].examsPro.filter(obj => examslist[obj].emission !== "Derivaciones" && examslist[obj].emission !== "")].length / ExamsShown)-1).keys()].map((dots) => (
              <div className="ExamRecommendationFormInnerBoxLowerLinesIndividualPageDot" key={'pageDot'.concat(dots+2)} id={'pageDot'.concat(dots+2)}></div>
            ))}
          </div>
          </>}
          {[...packslist[VisualizePack].exams.filter(obj => examslist[obj].emission === "Derivaciones"),...packslist[VisualizePack].examsPro.filter(obj => examslist[obj].emission === "Derivaciones")].length !== 0 ?
         <>
        <div className="ExamChoiceByGenderAllExamsDerivations">
          <h5 className="ExamChoiceByGenderAllExamsPageMainTitle">Derivaciones:&ensp; ({[...packslist[VisualizePack].exams.filter(obj => examslist[obj].emission === "Derivaciones"),...packslist[VisualizePack].examsPro.filter(obj => examslist[obj].emission === "Derivaciones")].length}) &nbsp;
          <img className="ExamChoiceByGenderAllExamsPageIcon" alt='' src={TinyPageIcon} />
        </h5>
        <div className="ExamChoiceByGenderAllExamsHorizontalLine"></div>
          <div className="ExamChoiceByGenderAllExamsFlexFullLine">
            <div className="ExamChoiceByGenderAllDerivationsFlexExamLine">
              {[...packslist[VisualizePack].exams.filter(obj => examslist[obj].emission === "Derivaciones"),...packslist[VisualizePack].examsPro.filter(obj => examslist[obj].emission === "Derivaciones")].map((exam) => (
              <div className="ExamChoiceByGenderAllDerivationsSingleExamBlock" key={exam}>
                <div className="ExamChoiceByGenderAllExamsSingleExamBlockUpLine">
                  <img className="ExamChoiceByGenderAllExamsExamIcon" alt='' src={TinyExamIcon} />&ensp;
                  <div className="ExamChoiceByGenderAllExamsSingleExamBlockName">{examslist[exam].name}</div>
                </div>
                <div className="ExamChoiceByGenderAllExamsSingleExamBlockDescr">{examslist[exam].description}</div>
              </div>
              ))}
            </div>
          </div>
        </div>
        </> : null}
      </div>
     </div>
      }

        </div>
        <MakeItEasy/>
        <div className='ScrollBackToTopOuter ScrollBackToTopHidden' id="ToTheTop">
            <div className='ScrollBackToTop' onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0;}}>
            <FontAwesomeIcon 
                icon={faUpLong} 
                className='ScrollBackToTopUpArrow'
            />
            </div>
        </div>
        </>
        }
        </>
    );
}

export default ExamChoiceByPhysicalSaleRoute;